/**
 * Base font size of the site. Used with `htmlFontSize` and `pxToRem` calculations
 */
export const baseFontSize = 16;
/**
 * Application header height
 */
export const appHeaderHeight = 64;
/**
 * Global transition speed for CSS animations
 */
export const transitionSpeed = '0.25s';
/**
 * LeftNav component max width
 */
export const navMaxWidth = 310;
/**
 * LeftNav component min width
 */
export const navMinWidth = 72;
/**
 * TopNav component base height
 */
export const topNavHeight = 53;
/**
 * Converts an array of pixel values to a string of rem values.
 *
 * This function takes an array of numbers representing pixel values and converts each
 * value to rem units based on the base font size.
 *
 * @param {number[]} values - An array of numbers representing pixel values to be converted.
 * @returns {string} A string of rem values separated by spaces.
 */
export const pxToRem = (...values) => {
    return values.map((value) => `${value / baseFontSize}rem`).join(' ');
};
